import { Segment } from '@fixter/i18n';
import type { CmsPageCollectionItems } from '$cms/types';
import type { VrmLookupTranslatedEntities } from '../../types';

/**
 * @deprecated set heading in CMS
 * @todo remove hardcoded translations
 */
export function getVrmLookupHeading(
  translatedEntities: VrmLookupTranslatedEntities,
  collections: CmsPageCollectionItems = {},
  segment?: Segment
): string {
  const { product, area, carMake, carModel } = collections;
  const frSegment = segment === Segment.Fixter_FR;

  if (product?.name) {
    if (area?.name) {
      return frSegment
        ? `${product.name.charAt(0).toUpperCase() + product.name.slice(1)} à ${area.name}`
        : `${product.name.charAt(0).toUpperCase() + product.name.slice(1)} in ${area.name}`;
    }

    if (carMake?.name && carModel?.name) {
      return frSegment
        ? `${product.name.charAt(0).toUpperCase() + product.name.slice(1)} de votre ${carMake.name} ${
            carModel.name
          }`
        : `${carMake.name} ${carModel.name} ${product.name}`;
    }
    if (carMake?.name) {
      return frSegment
        ? `${product.name.charAt(0).toUpperCase() + product.name.slice(1)} de votre ${carMake.name}`
        : `${carMake.name} ${product.name}`;
    }

    return frSegment
      ? `${product.name.charAt(0).toUpperCase() + product.name.slice(1)}, simple et rapide`
      : `Hassle-free ${product.name}`;
  }

  if (area?.name) {
    if (carMake?.name) {
      return frSegment
        ? `Économisez jusqu'à -30% sur les réparations de votre ${carMake.name} à ${area.name}!`
        : `Save up to 30% on your next ${carMake.name} repairs in ${area.name}`;
    }
    return frSegment
      ? `Économisez jusqu'à -30% sur vos prochaines réparations auto à ${area.name}!`
      : `Save up to 30% on your next car repairs in ${area.name}`;
  }

  if (carMake?.name) {
    if (carModel?.name) {
      return frSegment
        ? `Faites réparer votre ${carMake.name} ${carModel.name} par les meilleurs garages à proximité`
        : `Get your ${carMake.name} ${carModel.name} fixed by the best local garage`;
    }
    return frSegment
      ? `Faites réparer votre ${carMake.name} par les meilleurs garages à proximité`
      : `Get your ${carMake.name} fixed by the best local garage`;
  }

  if (translatedEntities?.heading) {
    return translatedEntities.heading.value;
  }

  return frSegment
    ? 'Faites réparer votre voiture par le meilleur garage local'
    : 'Get your car fixed by the best local garage';
}
